class WIquickAdd extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.clickOnSingleVariant();
  }
  clickOnSingleVariant() {
    if(this.querySelector('.WI_completeLook_options')){
      let selectElement = this.querySelector('.WI_completeLook_options');
      let WI_quickAdd_atc = this.querySelector('.WI_quickAdd_atc');
      selectElement.addEventListener('change', function(){
        WI_quickAdd_atc.setAttribute("data-variantid", this.value);
      });
    }
    this.querySelectorAll(".WI_quickAdd_atc").forEach((variant) => {
      variant.addEventListener("click", async (e) => {
        e.preventDefault();
         const Mspan = variant.querySelector('.Ma-span'); 
          const spinner = variant.querySelector('.loading__spinner'); 
          spinner.classList.remove('hidden');
          Mspan.style.opacity = 0;

        
        let formData = {
          items: [{ id: variant.getAttribute("data-variantid"), quantity: 1 }],
        };
        await fetch("/cart/add", {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
        
        let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
        let emptyCart =  document.querySelector('.WI_cartDrawerin_cart_empty');
        
        
        if (loadingCartBlock != null) {
            loadingCartBlock.style.display = "block";
        }
        if (emptyCart != null) {
            emptyCart.style.display = "none";
        }
        document.querySelector('wi-cartdrawer').updateCart();
        
        spinner.classList.add('hidden');
        Mspan.style.opacity = 1;
        
      });
      });
    }
      
}
customElements.define("wi-quickadd", WIquickAdd);